import { IoTrashOutline } from "react-icons/io5";
import ImageLoader from "../../../../components/imageLoader";
import IncrementalButton from "../../../../components/incrementalButton";
import { useMainContext } from "../../../../context";
import maskMoney from "../../../../utils/maskMoney";
import { useCartContext } from "../../context";
import { useCallback } from "react";

const CartOrderSummary = () => {
  const { order } = useMainContext();
  const { controlRender, addChangeQnt, calcItem } = useCartContext();

  const totalValue = useCallback(
    (item, index) => calcItem(item, index) * item.qnt,
    [calcItem],
  );

  const renderRequiredItem = useCallback((option, priceMethod = 1) => {
    const price = option.price ? maskMoney(option.price) : "";
    let label = `${option.name}`;

    if (option.price > 0) {
      label = `${option.name} (+ ${price})`;
    }

    if (priceMethod === 2 && option.quantity > 0) {
      label = `${option.quantity}x ${option.name} (+ ${price})`;
    }

    return (
      <p className="text-sm text-primary-700 font-medium" key={option.id}>
        {label}
      </p>
    );
  }, []);

  const renderAdditionalItem = useCallback((option) => {
    const price = option.price ? maskMoney(option.price) : "";
    let label = `${option.name}`;

    if (option.price > 0) {
      label = `${option.name} (+ ${price})`;
    }

    return (
      <li
        className="text-sm text-gray-500 italic font-medium ml-5"
        key={option.id}
      >
        {label}
      </li>
    );
  }, []);

  const renderRequireds = useCallback(
    (item) => {
      const options = [];

      item?.product?.requireds?.forEach((groupRequired) => {
        groupRequired?.groupsOptions?.forEach((groupOption) => {
          groupOption?.options?.forEach((option) => {
            if (option?.selected) {
              options.push(
                renderRequiredItem(
                  option,
                  item.product.category?.price_method ?? 1,
                ),
              );
            }
          });
        });
      });

      return options;
    },
    [renderRequiredItem],
  );

  const renderAdditionals = useCallback(
    (item) => {
      const options = [];

      item?.product?.groupsAdditionals?.forEach((groupAdditional) => {
        groupAdditional?.additionals?.forEach((additional) => {
          if (additional?.selected) {
            options.push(renderAdditionalItem(additional));
          }
        });
      });

      return options;
    },
    [renderAdditionalItem],
  );

  return (
    <>
      <p className="text-2xl font-black uppercase text-black border-l-4 border-primary-500 pl-4 mb-6">
        SEU PEDIDO
      </p>

      {!controlRender && (
        <div className="flex flex-col space-y-4">
          {order.items.map((item, indexItem) => (
            <div
              key={`${item.product.id}-${indexItem}`}
              className="flex flex-row gap-4 border-2 border-gray-200 rounded-xl p-4 hover:bg-gray-100/75 hover:border-gray-300 hover:shadow-sm transition-colors"
            >
              <div className="h-32 w-32 overflow-hidden hidden md:block rounded-lg">
                <ImageLoader
                  alt={item.product.name}
                  src={
                    item.product.photo
                      ? `${process.env.REACT_APP_SERVER_BETABIT_BASE_API}/files/products/${item.product.photo}`
                      : undefined
                  }
                />
              </div>

              <div className="flex flex-1 flex-col">
                <div className="flex flex-col md:flex-row gap-2 md:items-center md:justify-between font-bold text-xl mb-4">
                  <span>
                    {item.product.name}
                    {item.product.category.has_one_size
                      ? ""
                      : ` - ${item.product.size.name}`}
                  </span>

                  <span className="text-primary-500">
                    {maskMoney(totalValue(item, indexItem))}
                  </span>
                </div>

                {(item.product?.requireds.length > 0 ||
                  item.product?.groupsAdditionals.length > 0) && (
                  <div className="mb-2 space-y-2">
                    {item.product.requireds.length > 0 && (
                      <div>
                        <p className="text-sm leading-tight mb-1 font-medium text-gray-500">
                          ESCOLHAS
                        </p>
                        <div>{renderRequireds(item)}</div>
                      </div>
                    )}

                    {item.product.groupsAdditionals.length > 0 && (
                      <div>
                        <p className="text-sm leading-tight mb-1 font-medium text-gray-500">
                          ADICIONAIS
                        </p>
                        <div>{renderAdditionals(item)}</div>
                      </div>
                    )}
                  </div>
                )}

                {!!item.comments && (
                  <div className="border-l-4 border-secondary-500 bg-secondary-100/50 rounded-lg p-3 mb-2">
                    <p className="text-xs leading-tight font-bold">
                      OBSERVAÇÃO
                    </p>
                    <p className="text-sm">{item.comments}</p>
                  </div>
                )}

                <div className="flex flex-row flex-1 items-end justify-between gap-8 mt-2">
                  <IncrementalButton
                    onDecrease={() => addChangeQnt(indexItem, item.qnt - 1)}
                    onIncrease={() => addChangeQnt(indexItem, item.qnt + 1)}
                    size="sm"
                    value={item.qnt}
                  />

                  <button
                    onClick={() => addChangeQnt(indexItem, 0)}
                    className="h-10 w-10 flex items-center justify-center cursor-pointer rounded-full hover:bg-gray-200 hover:scale-110 transition"
                  >
                    <IoTrashOutline className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CartOrderSummary;
